import axios from 'axios';
import { JWT_TOKEN } from '../../constants';
import { optimize } from 'webpack';
import { env } from '../../utils/env';

export class AxiosWrapper {
  static getConfig(options?: any) {
    let config = options;
    const auth = authHeader();
    if (auth) {
      config = { headers: authHeader(), ...options };
    }
    return config;
  }

  static get<T = any>(path: string, options?: any): Promise<T> {
    const url = env.API + path;
    return axios
      .get(url, AxiosWrapper.getConfig(options))
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static public<T = any>(path: string, options: any = {}): Promise<T> {
    const url = env.API + path;
    return axios
      .get(url, options)
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static head<T = any>(path: string): Promise<T> {
    return axios
      .head(path)
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static post<T, V = any>(path: string, body?: T, options?: any): Promise<V> {
    const url = env.API + path;

    return axios
      .post(url, body, AxiosWrapper.getConfig(options))
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static delete<V = any>(path: string, options?: any): Promise<V> {
    const url = env.API + path;

    return axios
      .delete(url, AxiosWrapper.getConfig(options))
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static downloadBlobFromPost<T, V = any>(path: string, body?: T, options?: any): Promise<V> {
    const url = env.API + path;

    return axios
      .post(url, body, AxiosWrapper.getConfig({ ...(options ? options : {}), responseType: 'blob' }))
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        return response;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  static getAsset<T = any>(path: string, options?: any): Promise<T> {
    return axios
      .get(path, { ...(options ? options : {}), responseType: 'blob' })
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static getAssetArrayBuffer<T = any>(path: string, options?: any): Promise<T> {
    return axios
      .get(path, { ...(options ? options : {}), responseType: 'arraybuffer' })
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static getJson<T = any>(path: string, options?: any): Promise<T> {
    return axios
      .get(path, {
        ...(options ? options : {}),
        responseType: 'json',
      })
      .then((response: any) => {
        return response;
      });
    // .catch((error) => {
    //     throw error;
    // });
  }

  static getBlob<T = any>(path: string, options?: any): Promise<T> {
    return axios
      .get(path, { ...(options ? options : {}), responseType: 'blob' })
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }

  static getText<T = any>(path: string, options?: any): Promise<T> {
    return axios
      .get(path, { ...(options ? AxiosWrapper.getConfig(options) : {}), responseType: 'text' })
      .then((response: any) => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }
}

export function authHeader() {
  const token = localStorage.getItem(JWT_TOKEN);
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  return null;
}
